import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  selectedDocumentReducer,
  initialSelectedDocumentState
} from '@shared/context/reducers/SelectedDocumentReducer';
import {
  setSelectedDocument,
  removeSelectedDocument,
  clearSelectedDocument
} from '@shared/context/actions/SelectedDocumentActions';
import {SelectedDocumentModel} from '@shared/context/mappers/SelectedDocumentTypesMapper';

interface SelectedDocumentInterface {
  readonly SelectedDocumentState: SelectedDocumentModel;
  readonly setSelectedDocumentData: (data: object) => void;
  readonly removeSelectedDocumentData: (data: object) => void;
  readonly clearSelectedDocumentData: (data?: object) => void;
}

const SelectedDocumentContext = createContext<SelectedDocumentInterface>(
  {} as SelectedDocumentInterface
);

export const useSelectedDocumentContext = (): SelectedDocumentInterface =>
  useContext(SelectedDocumentContext);

export const SelectedDocumentProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [SelectedDocumentState, dispatch] = useReducer(
    selectedDocumentReducer,
    initialSelectedDocumentState
  );

  const setSelectedDocumentData = (data: any): void => {
    setSelectedDocument(dispatch, data);
  };

  const removeSelectedDocumentData = (data: any): void => {
    removeSelectedDocument(dispatch, data);
  };

  const clearSelectedDocumentData = (data: any): void => {
    clearSelectedDocument(dispatch, data);
  };

  return (
    <SelectedDocumentContext.Provider
      value={{
        SelectedDocumentState,
        setSelectedDocumentData,
        removeSelectedDocumentData,
        clearSelectedDocumentData
      }}>
      {children}
    </SelectedDocumentContext.Provider>
  );
};
